export default __webpack_public_path__ + "static/N0258-b4a30f6515767509c4dbd2047fc2fd9d.png";